__turbopack_context__.v({
  "quizCtaWrapper": "_0aepKG_quizCtaWrapper",
  "scrollShadow": "_0aepKG_scrollShadow",
});
